import { Link } from "react-router-dom";
import { aboutImage, site } from "@/mocks/site";

const principles = [
  { icon: "ri-shield-user-line", text: "所有亲述均以化名呈现，可识别信息做模糊处理" },
  { icon: "ri-file-text-line", text: "只呈现事实与感受，不为流量制造结论" },
  { icon: "ri-hand-heart-line", text: "内容服务于当事人，而非围观者的情绪" },
];

export default function AboutPreview() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-editorial mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="rounded-lg overflow-hidden bg-background-200 h-64 md:h-[380px]">
            <img
              src={aboutImage}
              alt="安静的书桌上放着笔记本与暖光台灯，象征对网暴黑料当事人的记录与倾听"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-400"></span>
              关于 {site.name}
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              我们不消费伤害，只负责把话说清楚
            </h2>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">{site.intro}</p>

            <ul className="mt-8 flex flex-col gap-4">
              {principles.map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700 pt-2">{item.text}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}